module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "extraButton",
    on: {
      "click": function($event) {
        return _vm.$emit("click")
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c7df506","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/parts/extra_buttons/ExtraButton.vue
// module id = 75a199a1adce5d890b39
// module chunks = 0